import { useMedia } from 'react-use';

export const usePrefersReducedMotion = () =>
  useMedia('(prefers-reduced-motion: reduce)', false);
